import React, { useEffect, useState } from 'react'

import './PaymentSuccess.css'
import Navbar from '../../Components/Navbar/Navbar';
import Footer from '../../Components/Footer/Footer';

const PaymentSuccess = () => {
    const [url,setUrl]= useState("");
  return (
    <>
      <Navbar/>
    <div className='p-success-outer'>
      <div className='p-top'>
            <i className="fa-regular fa-circle-check"></i>
            <h3>Payment Successfull!</h3>
            <p>Your order is Successfull annd will be processed soon!</p>
          </div>
      </div>
      <Footer/>
    </>
  )
}

export default PaymentSuccess
